import AfterPseudoElements from "./components/AfterPseudoElements"
import Animate2 from "./components/Animate2"
import Autoplay from "./components/Autoplay"
import Autoplay2 from "./components/Autoplay2"
import Filter from "./components/Filter"
import MapSK from "./components/MapSK"
import Menu from "./components/Menu"
import PreLoading from "./components/PreLoading"
import SiteInvert from "./components/SiteInvert"
import TitleScroll from "./components/TitleScroll"
import SwiperJS from "./components/SwiperJS"
import VideoQuery from "./components/VideoQuery"
import FadeIn from "./components/FadeIn"
import ClipIn from "./components/ClipIn"
import MediaPlayer from "./components/MediaPlayer"
import HeaderScroll from "./components/HeaderScroll"
import CountryPick from "./components/CountryPick"
import RandomAnimation from "./components/RandomAnimation"

let root = {}
document.addEventListener('DOMContentLoaded', () => {
    root.menu = new Menu(root)
    root.swiperJS = new SwiperJS(root)
    root.videoQuery = new VideoQuery(root)
    root.animate2 = new Animate2(root)
    root.autoplay = new Autoplay(root)
    root.autoplay2 = new Autoplay2(root)
    root.afterPseudoElements = new AfterPseudoElements(root)
    root.filter = new Filter(root)
    root.preLoading = new PreLoading(root)
    root.siteInvert = new SiteInvert(root)
    root.titleScroll = new TitleScroll(root)
    root.fadeIn = new FadeIn(root)
    root.clipIn = new ClipIn(root)
    root.mediaPlayer = new MediaPlayer(root)
    new HeaderScroll(root)
    new CountryPick(root)
    new RandomAnimation(root)
}, false)

window.initMap = function() {
    root.mapSK = new MapSK(root)
}
